module.exports = __webpack_public_path__ + "jab/media/emblem.d0289dc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/emblem.png
// module id = 1972
// module chunks = 0